import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'deMoneyFormat',
    standalone: false
})
export class MoneyFormatPipe extends CurrencyPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let result;
    result = super.transform(value, args);
    return result;
  }
}
